import { useEffect } from "react";
import { useLogout } from "../../../../hooks/useLogout";

const LogoutPage = () => {
  const logoutFunction = useLogout();

  useEffect(() => {
    logoutFunction();
  }, []);

  return null;
};

export default LogoutPage;
